export default "__VITE_ASSET__43e4ba0c__"